import {
    Box,
    Button,
    CircularProgress,
    IconButton,
    Modal,
    Typography,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline"
import { useNavigate } from "react-router-dom"
import { clearLocalstorage } from "../../../../helper/utils"

type IdleAlertProps = {
    open: boolean
    setOpen: any
}

const IdleAlert = ({
    open,
    setOpen,
}: IdleAlertProps) => {

    const navigate = useNavigate();

    const handleClose = () => {
        clearLocalstorage();
        navigate('/auth')
        setOpen(false);
    }

    return (
        <Modal
            open={open}
            // onClose={handleClose}
            aria-labelledby="idle-alert-modal"
            aria-describedby='idle-alert'
        >
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    borderRadius: "8px",
                    transform: "translate(-50%, -50%)",
                    width: 450,
                    bgcolor: "#fff",
                    boxShadow: 24,
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "12px",
                        paddingBottom: "30px",
                        paddingTop: "50px",
                    }}
                >
                    <ErrorOutlineIcon color="error" sx={{ fontSize: "50px" }} />
                    <IconButton
                        sx={{
                            position: "absolute",
                            top: 2,
                            right: 2,
                        }}
                        onClick={handleClose}
                    >
                        <CloseIcon />
                    </IconButton>

                    <Typography
                        sx={{
                            fontSize: "18px",
                            fontWeight: "bold",
                            textAlign: "center",
                            mx: "20px",
                        }}
                    >
                        Idle Alert
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: "14px",
                            color: "#707070",
                            textAlign: "center",
                            mx: "20px",
                        }}
                    >
                        You have been logged out due to inactivity, Please login again.
                    </Typography>
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        px: "20px",
                    }}
                >
                    <Button
                        variant="contained"
                        sx={{
                            textTransform: "none",
                            fontWeight: "bold",
                            color: "#fff",
                            px: "60px",
                            display: "flex",
                            mb: "30px",
                        }}
                        onClick={handleClose}
                    >
                        Login
                    </Button>
                </Box>
            </Box>
        </Modal>
    )
}

export default IdleAlert